<template>
	<div class="badge-container">
		<div class="flex badge-container_box">
			<img :src="require('../../assets/image/community/' + (badge && !states ? 'a' : '') + images + (states ? 's' : '') + '.png')" class="image" />
			<div class="num" v-if="!badge && nums>0" >
				{{ formatQuantity(nums) }}
			</div>
		</div>
		<div class="badge" v-if="badge && nums>0 ">{{ formatQuantity(nums) }}</div>
	</div>
</template>

<script>
import {formatQuantity } from "@/utils/index";
export default {
	props: {
		id: {
			type: Number,
			default: 0
		},
		num: {
			type: Number,
			default: 0
		},
		state: {
			type: [Number,Boolean],
			default: 0
		},
		image: {
			type: String,
			default: ''
		},
		badge: {
			type: Boolean,
			default: false
		},

		comment: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			states: this.state?1:0,
			nums: this.num,
			images: this.image
		};
	},
	mounted(){

	},
	
	methods: {
		formatQuantity,
		amount(e) {
			let unm = e;
			if (e > 9999) {
				unm = e / 10000;
				unm = Number(unm.toString().match(/^\d+(?:\.\d{0,1})?/)) + 'W';
			} else if (e > 999) {
				unm = e / 1000;
				unm = Number(unm.toString().match(/^\d+(?:\.\d{0,1})?/)) + 'K';
			}
			return unm;
		},

	}
};
</script>

<style scoped lang="scss">
.flex {
	display: flex;
}
.image {
	width: .48rem /* 36/75 */;
	height: .48rem /* 36/75 */;
}
.num {
	color: #b8b8b8;
	margin-left: .186667rem /* 14/75 */;
	font-size: .266667rem /* 20/75 */;
	white-space: nowrap;
}
.kuangzi {
	border: .013333rem /* 1/75 */ solid red;
}

.badge-container {
	position: relative;
	display: inline-block;
	.badge-container_box{
		align-items: center;
	}
}

.badge {
	position: absolute;
	top: 0;
	right: 0;
	transform: translate(100%, -50%);
	color: #b8b8b8;
	font-size: .213333rem /* 16/75 */;
	white-space: nowrap;
}
</style>
